import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import NotificationComponent from '../ui/Notification';
import PWNotification from '../components/PWNotification';

interface NotificationContextProps {
    isOpen: boolean;
    message: React.ReactNode;
    action: React.ReactNode;
    type: 'FilterNotification' | 'NoDataNotification'; // Updated names
    className?: string;
    isDisplayCloseIcon?: boolean;
    showNotification: (type: 'FilterNotification' | 'NoDataNotification', message: React.ReactNode, action?: React.ReactNode, className?: string, isDisplayCloseIcon?: boolean, hideAfterTimeout?: boolean) => void;
    //showNotification: (message: React.ReactNode, action: React.ReactNode) => void;
    hideNotification: () => void;
    displayNotification: boolean;
    setDisplayNotification: (value: boolean) => void;
    notificationContent: React.ReactNode;
    setNotificationContent: (content: React.ReactNode) => void;
    shouldHideAfterTimeout: boolean; // Flag for timeout control
    setShouldHideAfterTimeout: (value: boolean) => void; // Method to set the flag

    displayCardNotification:boolean;
    seIsDisplayCardNotification:(value: boolean) => void;
    cardNotificationContent:React.ReactNode;
    setCardNotificationContent:(content: React.ReactNode) => void;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};

interface NotificationProviderProps {
    children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState<ReactNode>(null);
    const [action, setAction] = useState<ReactNode>(null);
    const [type, setType] = useState<'FilterNotification' | 'NoDataNotification'>('FilterNotification');
    const [className, setClassName] = useState<string | undefined>(undefined);
    const [isDisplayCloseIcon, setIsDisplayCloseIcon] = useState<boolean>(false);
    const [displayNotification, setDisplayNotification] = useState<boolean>(false);
    const [notificationContent, setNotificationContent] = useState<ReactNode>(null);
    const [hideAfterTimeout, setHideAfterTimeout] = useState<boolean>(false);
    const [shouldHideAfterTimeout, setShouldHideAfterTimeout] = useState<boolean>(false);

    const [displayCardNotification , seIsDisplayCardNotification] = useState<boolean>(false)
    const [cardNotificationContent , setCardNotificationContent] = useState<ReactNode>(null)
   

    // const showNotification = (message: ReactNode, action?: ReactNode) => {
    //     setMessage(message);
    //     setAction(action);
    //     setIsOpen(true);
    // };

    const showNotification = (
        type: 'FilterNotification' | 'NoDataNotification',
        message: ReactNode,
        action?: ReactNode,
        className?: string,
        isDisplayCloseIcon?: boolean,
        hideAfterTimeout: boolean = false
    ) => {
        setType(type);
        setMessage(message);
        setAction(action || null);
        setClassName(className || undefined);
        setIsOpen(true);
        setIsDisplayCloseIcon(isDisplayCloseIcon!);
        setHideAfterTimeout(hideAfterTimeout);
    };

    const hideNotification = () => {
        setIsOpen(false);
        setMessage(null);
        setAction(null);
        setClassName(undefined);
        setShouldHideAfterTimeout(false);
    };

    useEffect(() => {
        if (displayNotification && shouldHideAfterTimeout) {
            const timeoutId = setTimeout(() => {
                hideNotification(); // Hide the notification after 5 seconds
            }, 5000); // 5 seconds timeout

            return () => clearTimeout(timeoutId); // Cleanup the timeout on component unmount or state change
        }
    }, [displayNotification, shouldHideAfterTimeout]);

    return (
        <NotificationContext.Provider value={{
            isOpen, message, action, type, className, isDisplayCloseIcon,
            showNotification, hideNotification, displayNotification, setDisplayNotification,
            notificationContent, setNotificationContent, shouldHideAfterTimeout, setShouldHideAfterTimeout,displayCardNotification,seIsDisplayCardNotification,
            cardNotificationContent,setCardNotificationContent
        }}>
            {children}
            {type === 'FilterNotification'  && (
                <NotificationComponent />
            )}
            {/* {type === 'NoDataNotification'  && (
                <PWNotification message={message} setIsNotification={setIsOpen} className={className} isDisplayCloseIcon={isDisplayCloseIcon} />
            )} */}
            {/* <NotificationComponent /> */}
        </NotificationContext.Provider>
    );
};
